import { extendTheme } from '@chakra-ui/react';
import styles from './styles';
import colors from './colors';
import Input from './components/Input';
import Button from './components/Button';

export default extendTheme({
  styles,
  colors,
  fonts: {
    body: 'Open Sans, Roboto, PingFang HK',
  },
  components: {
    Input,
    Button,
    Link: {
      baseStyle: {
        color: 'primary.main',
        fontSize: '14px',
        fontWeight: 600,
      },
    },
  },
});
